module.exports = __webpack_public_path__ + "img/provider14.21414971.png";